<mat-card>
  <div style="text-align:center">
    <h1>
      Welcome to EquipMySchool's Admin Portal
    </h1>
    <img width="300" src="/assets/img/logo.svg" />
  </div>
  <p>Use the links in the menu on the left to get started. </p>
</mat-card>
